/**
 * @file api配置
 */
import api from './create-api';
const isDebugger = !window.location.protocol.includes('https');
const cfwOrigin = isDebugger ? 'http://activityweb.yz.test.autohome.com.cn' : 'https://chefuwu.autohome.com.cn';
export default {
  isDebugger,
  /**
   * 根据code获取活动配置项
   */
  getActivitySetting(params) {
    return api.get(`${cfwOrigin}/activity/yx/guess/getActivityInfo`, params);
  },
  /**
   * 获取竞猜列表
   */
  getUserList(params) {
    return api.get(`${cfwOrigin}/activity/yx/guess/getUserList`, params);
  },
  /**
 * 获取用户是否登录信息
 */
  getIsLogin(params) {
    return api.get(`${isDebugger ? 'http://orderapi.yz.test.autohome.com.cn' : 'https://chefuwu.autohome.com.cn'}/orderapi/identity/getLoginUserInfo.do`, params);
  },
  /**
   * 微信分享签名授权
   */
  getWXShareSign(params) {
    return api.post(`/cus/v1_0_0/api/wx/auth/shareSign`, params);
  },
  /**
   * 竞猜接口
   */
  getGuess(params) {
    return api.get(`${cfwOrigin}/activity/yx/guess/guess`, params);
  },
  /**
   * 活动添加提醒
   */
  getRemindMe(params) {
    return api.get(`${cfwOrigin}/activity/yx/guess/remindMe`, params);
  },
  /**
   * 获取活动结果
   */
  getActivityResult(params) {
    return api.get(`${cfwOrigin}/activity/yx/guess/getActivityResult`, params);
  },
  /**
   * 获取往期，预告、中奖活动
   */
  getActivityRecord(params) {
    return api.get(`${cfwOrigin}/activity/yx/guess/getActivityRecord`, params);
  },
  /**
   * 点赞操作
   */
  getLike(params) {
    return api.get(`${cfwOrigin}/activity/yx/guess/like`, params);
  },
  /**
   * 每天登录获取一次竞猜机会
   */
  addActivityQualificationByLoginUser(params) {
    return api.get(`${cfwOrigin}/activity/yx/addActivityQualificationByLoginUser`, params);
  }
};

